import React from "react"
import { Heading, Link } from "../../ui"
import { EMediaTypes } from "packages/gatsby-theme-strapi/gatsby-graphql"
import downloadIcon from "../../assets/icons/download-icon.svg"
import videoPlay from "../../assets/icons/video-play.svg"
import {
  Container,
  Description,
  DescriptionContainer,
  ImageContainer,
  Media,
  MediaOptions,
  OptionIcon,
  TitleSection,
  VideoPlay,
} from "./media-preview-elements"

interface MediaPreviewProps {
  type: EMediaTypes
  title: string
  description: string
  thumbUrl: string
  fileUrl: string
  onClick?: (...args: any) => void
}

const MediaPreview = ({
  type,
  title,
  description,
  thumbUrl,
  fileUrl,
  onClick,
}: MediaPreviewProps) => {
  return (
    <Container>
      <ImageContainer onClick={onClick}>
        <Media src={thumbUrl} alt="media" />
        {type === "VIDEO" && <VideoPlay src={videoPlay} alt="video-play" />}
      </ImageContainer>
      <DescriptionContainer>
        <TitleSection>
          <Heading.H4>{title}</Heading.H4>
          <MediaOptions>
            <Link to={fileUrl} target="newWindow" download={title}>
              <OptionIcon src={downloadIcon} alt={"download-icon"}/>
            </Link>
          </MediaOptions>
        </TitleSection>
        {description && <Description>{description}</Description>}
      </DescriptionContainer>
    </Container>
  )
}

export default MediaPreview
